import type { MailboxInfo } from 'owa-client-types';
import getAccountSourceListStore from '../store/accountSourceListStore';
import getAccountBySourceId from './getAccountBySourceId';

export default function getSelectedAccountMailboxInfo(): MailboxInfo {
    const selectedAccount = getAccountBySourceId(getAccountSourceListStore().selectedSourceId);

    if (!selectedAccount) {
        throw new Error('No account is selected');
    }

    if (!selectedAccount.mailboxInfo) {
        throw new Error('Selected account lacks MailboxInfo');
    }

    return selectedAccount.mailboxInfo;
}
